import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import AutoReplenishment from 'components/RichProfile/MyAccount/AutoReplenishment';
import AutoReplenishmentSummary from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentSummary';
import { useAutoReplenishmentHub } from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentHub/hooks/useAutoReplenishmentHub';
import { useSubscriptions } from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentHub/hooks/useSubscriptions';

/**
 * Entry point for the AutoReplenishment hub. Resolves Redux state via hooks
 * (auth, user, subscriptions, CMS, feature flags, localization) and renders:
 * - AutoReplenishmentSummary (when logged in and subscriptions exist)
 * - AutoReplenishment controller with all required props
 */
const AutoReplenishmentHub = () => {
    const {
        localization, featureFlags, cmsData, biPoints, displaySignIn, user, isLoggedIn
    } = useAutoReplenishmentHub();
    const {
        currentSubscriptionPaymentData, allSubscriptions, currentSubscription, setCurrentSubscription, updateCurrentSubscription
    } =
        useSubscriptions();

    const { isAutoReplenishEmptyHubEnabled } = featureFlags;
    const { active: activeCount, paused: pausedCount, cancelled: cancelledCount } = allSubscriptions;

    const hasSummary = activeCount > 0 || pausedCount > 0 || (isAutoReplenishEmptyHubEnabled && cancelledCount > 0);

    return (
        <>
            {isLoggedIn && hasSummary && (
                <AutoReplenishmentSummary
                    allSubscriptions={allSubscriptions}
                    biPoints={biPoints}
                    isAutoReplenishEmptyHubEnabled={isAutoReplenishEmptyHubEnabled}
                    localization={localization}
                />
            )}
            <AutoReplenishment
                allSubscriptions={allSubscriptions}
                cmsData={cmsData}
                currentSubscription={currentSubscription}
                currentSubscriptionPaymentData={currentSubscriptionPaymentData}
                displaySignIn={displaySignIn}
                featureFlags={featureFlags}
                isLoggedIn={isLoggedIn}
                localization={localization}
                setCurrentSubscription={setCurrentSubscription}
                updateCurrentSubscription={updateCurrentSubscription}
                user={user}
            />
        </>
    );
};

export default wrapFunctionalComponent(AutoReplenishmentHub, 'AutoReplenishmentHub');
